import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/logo-2.png';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
    const [nav, setNav] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const isHomePage = location.pathname === '/';

    const handleClick = () => setNav(!nav);

    const handleNavClick = (section) => {
        setNav(false);
        if (!isHomePage) {
            navigate(`/#${section}`);
        }
    };

    return (
        <header className='fixed w-full h-[80px] flex justify-between items-center px-4 sm:px-8 bg-[#0b1120]/85 backdrop-blur-md text-slate-200 z-50 border-b border-slate-800/80'>
            <div>
                {isHomePage ? (
                    <ScrollLink to="home" smooth={true} duration={500} className="cursor-pointer">
                        <img src={logo} alt="Sharvan Samala Logo" className="w-[120px] object-contain" />
                    </ScrollLink>
                ) : (
                    <RouterLink to="/">
                        <img src={logo} alt="Sharvan Samala Logo" className="w-[120px] object-contain" />
                    </RouterLink>
                )}
            </div>

            {/* Desktop Menu */}
            <nav aria-label="Main Navigation">
                <ul className='hidden md:flex items-center gap-6 font-medium text-sm text-gray-300'>
                    {isHomePage ? (
                        <>
                            <li className="hover:text-[#64ffda] cursor-pointer transition-colors">
                                <ScrollLink to="home" smooth={true} duration={500}>Home</ScrollLink>
                            </li>
                            <li className="hover:text-[#64ffda] cursor-pointer transition-colors">
                                <ScrollLink to="about" smooth={true} duration={500}>About</ScrollLink>
                            </li>
                            <li className="hover:text-[#64ffda] cursor-pointer transition-colors">
                                <ScrollLink to="skills" smooth={true} duration={500}>Skills</ScrollLink>
                            </li>
                            <li className="hover:text-[#64ffda] cursor-pointer transition-colors">
                                <ScrollLink to="work" smooth={true} duration={500}>Projects</ScrollLink>
                            </li>
                            <li>
                                <ScrollLink
                                    to="contact"
                                    smooth={true}
                                    duration={500}
                                    className="cursor-pointer border border-[#64ffda] text-[#64ffda] hover:bg-[#64ffda]/10 px-4 py-2 rounded transition-colors font-medium"
                                >
                                    Contact
                                </ScrollLink>
                            </li>
                        </>
                    ) : (
                        <>
                            <li className="hover:text-[#64ffda] transition-colors">
                                <RouterLink to="/">Home</RouterLink>
                            </li>
                            <li>
                                <RouterLink
                                    to="/"
                                    className="border border-[#64ffda] text-[#64ffda] hover:bg-[#64ffda]/10 px-4 py-2 rounded transition-colors font-medium"
                                >
                                    Contact
                                </RouterLink>
                            </li>
                        </>
                    )}
                </ul>
            </nav>

            {/* Hamburger Button */}
            <button
                onClick={handleClick}
                aria-label={nav ? "Close menu" : "Open navigation menu"}
                aria-expanded={nav}
                className='md:hidden z-10 text-gray-200 focus:outline-none p-2'
            >
                {!nav ? <FaBars size={22} /> : <FaTimes size={24} />}
            </button>

            {/* Mobile Menu Overlay */}
            <ul
                className={
                    !nav
                        ? 'hidden'
                        : 'fixed top-0 left-0 w-full h-screen bg-[#0b1120] flex flex-col justify-center items-center z-40 transition-all'
                }
            >
                {isHomePage ? (
                    <>
                        <li className='py-5 text-2xl font-medium'>
                            <ScrollLink onClick={() => handleNavClick('home')} to="home" smooth={true} duration={500}>
                                Home
                            </ScrollLink>
                        </li>
                        <li className='py-5 text-2xl font-medium'>
                            <ScrollLink onClick={() => handleNavClick('about')} to="about" smooth={true} duration={500}>
                                About
                            </ScrollLink>
                        </li>
                        <li className='py-5 text-2xl font-medium'>
                            <ScrollLink onClick={() => handleNavClick('skills')} to="skills" smooth={true} duration={500}>
                                Skills
                            </ScrollLink>
                        </li>
                        <li className='py-5 text-2xl font-medium'>
                            <ScrollLink onClick={() => handleNavClick('work')} to="work" smooth={true} duration={500}>
                                Projects
                            </ScrollLink>
                        </li>
                        <li className='py-5 text-2xl font-medium'>
                            <ScrollLink onClick={() => handleNavClick('contact')} to="contact" smooth={true} duration={500} className="text-[#64ffda]">
                                Contact
                            </ScrollLink>
                        </li>
                    </>
                ) : (
                    <li className='py-5 text-2xl font-medium'>
                        <RouterLink onClick={handleClick} to="/" className="text-[#64ffda]">
                            Back to Home
                        </RouterLink>
                    </li>
                )}
            </ul>
        </header>
    );
};

export default Navbar;
